module.exports = ".list-group-item .icon{\n    margin-right: unset;\n}\n.media a {\n    color: #818c94;\n}\n.block_groups_gateway {\n    padding-top: 15px;\n    overflow: hidden;\n    -webkit-box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);\n            box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);\n    height: calc(100vh - 48px);\n    background-color: #fff;\n    border-radius: 8px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/admin/icontact/setting/switchboard/siptrunk/sip-trunk.component.css
// module id = ./src/app/pages/admin/icontact/setting/switchboard/siptrunk/sip-trunk.component.css
// module chunks = main